import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    overtimes: [],
    totalOvertimes: null,
    pageOvertimes: 1,
    perPageOvertimes: 5,
    overtimeDate: ["2019/01/19", "2019/12/29"],
    overtimeSearch: "",
    overtimeFilter: "",
    tableLoading: false,
  },
  actions,
  mutations,
};
